import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
function Identicon(_ref) {
  let {
    className = '',
    size,
    style = {}
  } = _ref;
  return _jsx("svg", {
    className: className,
    height: size,
    style: style,
    viewBox: '0 0 64 64',
    width: size
  });
}
export const Empty = React.memo(Identicon);